// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dEAUr{background-color:#eee}.dEAUr>div{font-size:20px;text-align:center}", "",{"version":3,"sources":["webpack://./src/desktop/components/RiddlesAdmin/Filter/filter.scss"],"names":[],"mappings":"AAAA,OACE,qBAAA,CAGF,WACE,cAAA,CACA,iBAAA","sourcesContent":[".rowFilter {\n  background-color: #eee;\n}\n\n.rowFilter > div {\n  font-size: 20px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowFilter": "dEAUr"
};
export default ___CSS_LOADER_EXPORT___;
